module.exports = __webpack_public_path__ + "hk.svg?ed1abd5f620a5bed9f3025e15ffe1a9b";